import type { ReactNode } from 'react'

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'

type Props = {
  title: string
  description?: string
  action?: ReactNode
  children: ReactNode
  contentClassName?: string
}

export function ProfileSection({
  title,
  description,
  action,
  children,
  contentClassName
}: Props) {
  return (
    <Card className='w-full gap-3'>
      <CardHeader>
        <div className='flex items-start justify-between gap-3'>
          <div className='space-y-1'>
            <CardTitle className='text-base'>{title}</CardTitle>
            {description ? (
              <CardDescription>{description}</CardDescription>
            ) : null}
          </div>
          {action}
        </div>
      </CardHeader>
      <Separator />
      <CardContent className={contentClassName}>{children}</CardContent>
    </Card>
  )
}
